module.exports = __webpack_public_path__ + "media/theme/sample-card__dmm-830865c2.jpg";